// src/components/Home.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BuddyToolList from './BuddyToolList';
import ConfirmationModal from './ConfirmationModal';

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get('invalid-tool') === 'true') {
      setIsModalOpen(true);
      // Clean the URL to remove the query parameter
      navigate('/home', { replace: true });
    }
  }, [location, navigate]);

  return (
    <>
      <BuddyToolList />
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={() => setIsModalOpen(false)}
        title="Tool Not Available"
        confirmText="OK"
        showCancel={false}
      >
        <p>The tool you requested does not exist or you are not licensed to use it.</p>
      </ConfirmationModal>
    </>
  );
};

export default Home;
